import { usePathname, useRouter } from 'expo-router';
import * as React from 'react';
import { Platform, Pressable } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { Icon } from '@/ui/icon';
import { ArrowLeft } from '@/ui/icons/arrow-left';

interface BackButtonProps {
  onPress?: () => void;
}

export default function BackButton({ onPress }: BackButtonProps) {
  const { theme } = useStyles();
  const router = useRouter();
  const pathname = usePathname();

  if (!router.canGoBack() && !onPress) return null;

  return (
    <Pressable
      hitSlop={16}
      onPress={() => {
        if (onPress) {
          onPress();
          return;
        }

        if (Platform.OS !== 'web') {
          router.back();
          return;
        }

        router.back();
        return;

        if (router.canGoBack()) {
          const pathSegments = pathname.split('/').filter(Boolean);

          if (pathSegments.length > 1) {
            // Remove the last segment to get the parent path
            const parentPath = `/${pathSegments.slice(0, -1).join('/')}`;
            router.replace(parentPath);
          } else {
            router.replace('/search');
          }
        }
      }}
      style={({ pressed }) => [
        {
          paddingLeft: Platform.OS === 'web' ? 16 : 0,
          opacity: pressed ? 0.5 : 1,
          backgroundColor: 'transparent',
        },
      ]}
    >
      <Icon
        type="naked"
        icon={<ArrowLeft />}
        fillColor={theme.colors.icon.color}
        width={15}
        height={15}
      />
    </Pressable>
  );
}
